var map = {
	"./2021/2021-paper1-6mark.json": 6747,
	"./2022/2022-paper1-6mark.json": 2645,
	"./2023/2023-paper1-6mark.json": 7363,
	"./2024/2024-paper1-6mark.json": 3393,
	"./2025/2025-paper1-6mark.json": 4275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9148;